import Swiper from 'swiper/bundle';

const SwiperGallery = () => {
    const sliders = document.querySelectorAll('.swiper');

    if (!sliders.length) return;

    sliders.forEach(slider => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.swiper__wrapper');

        if (!swiperWrapper) return;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: slider.querySelector('.swiper__pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper__nav--next'),
                prevEl: slider.querySelector('.swiper__nav--prev'),
            },
        });
    });
};

export default SwiperGallery;
